import firebase from 'firebase/app';

const firestore = firebase.firestore();

if (process.env.REACT_APP_ENVIRONMENT_NAME === 'EMULATOR') {
  firestore.useEmulator('localhost', 8080);
}

export default firestore;
